var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.625 15.7949L32.9485 19.5041C29.2262 21.572 27.3651 22.606 25.3941 23.0114C23.6496 23.3701 21.8504 23.3701 20.1059 23.0114C18.1349 22.606 16.2738 21.572 12.5515 19.5041L5.875 15.7949M11.875 36.4199H33.625C35.7252 36.4199 36.7754 36.4199 37.5775 36.0112C38.2831 35.6517 38.8568 35.078 39.2162 34.3724C39.625 33.5703 39.625 32.5201 39.625 30.4199V16.1699C39.625 14.0697 39.625 13.0196 39.2162 12.2175C38.8568 11.5118 38.2831 10.9382 37.5775 10.5787C36.7754 10.1699 35.7252 10.1699 33.625 10.1699H11.875C9.77481 10.1699 8.7247 10.1699 7.92254 10.5787C7.21692 10.9382 6.64324 11.5118 6.28373 12.2175C5.875 13.0196 5.875 14.0697 5.875 16.1699V30.4199C5.875 32.5201 5.875 33.5703 6.28373 34.3724C6.64324 35.078 7.21692 35.6517 7.92254 36.0112C8.7247 36.4199 9.77479 36.4199 11.875 36.4199Z",
    stroke: "#194775",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.061efbf6e1972edecb1c36bcfea11f8c.svg";
export { ForwardRef as ReactComponent };